import { useDeviceType } from '@cian/ui-kit';
import { useApplicationContext } from '../../../utils/applicationContext';
import { IOpenVillageBannerConfig, IOpenVillageBannerSettings } from '../../../types/banners';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectOpenVillageFilter } from '../../../selectors/filters';
import { useOpenVillageFilterAvailable } from '../../../hooks';

const LINK = '/country-builders-projects/?withOpenVillage=true';

export const useBannerConfig = (): IOpenVillageBannerConfig | null => {
  const deviceType = useDeviceType();
  const { config } = useApplicationContext();
  const openVillageFilterAvailable = useOpenVillageFilterAvailable();
  const openVillageFilterValue = useSelector(selectOpenVillageFilter);

  return useMemo(() => {
    const bannerSettings = config.get<IOpenVillageBannerSettings>('countryside.openVillage.banner');

    if (openVillageFilterValue || !bannerSettings || !openVillageFilterAvailable) {
      return null;
    }

    if (deviceType === 'desktop') {
      return {
        link: LINK,
        buttonSize: 'M',
        ...bannerSettings['desktop'],
      };
    }

    return {
      link: LINK,
      buttonSize: 'L',
      ...bannerSettings['mobile'],
    };
  }, [deviceType, config, openVillageFilterAvailable, openVillageFilterValue]);
};
